<template><div ref="content" style="display: none"><slot /></div></template>

<script>
function normalizePosition(position) {
  if (!position) return null
  const lat = Number(typeof position.lat === 'function' ? position.lat() : position.lat)
  const lng = Number(typeof position.lng === 'function' ? position.lng() : position.lng)
  return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null
}

export default {
  name: 'LeafletInfoWindow',
  inject: ['leafletMapContext'],
  props: {
    position: { type: Object, default: null },
    opened: { type: Boolean, default: false },
    options: { type: Object, default: () => ({}) }
  },
  data: () => ({ popup: null, destroyed: false }),
  watch: {
    opened() { this.syncPopup() },
    position: { deep: true, handler() { this.syncPopup() } },
    options: { deep: true, handler() { this.syncPopup() } }
  },
  mounted() {
    this.leafletMapContext.whenReady(() => {
      if (this.destroyed) return
      this.popup = window.L.popup({ closeButton: true })
      this.popup.on('remove', () => {
        if (this.opened) this.$emit('closeclick')
      })
      this.syncPopup()
    })
  },
  beforeDestroy() {
    this.destroyed = true
    if (this.popup && this.leafletMapContext.map) {
      this.leafletMapContext.map.closePopup(this.popup)
    }
  },
  methods: {
    syncPopup() {
      const map = this.leafletMapContext.map
      const position = normalizePosition(this.position)
      if (!map || !this.popup) return

      if (!this.opened || !position) {
        map.closePopup(this.popup)
        return
      }

      const content = this.options.content || this.$refs.content.innerHTML || ''
      this.popup.setLatLng(position).setContent(content).openOn(map)
    }
  }
}
</script>
